// The Safrati tokens (docs/ui-standard.md §2), as MUI palettes. Pages use
// these through the theme (primary.main, text.secondary, divider, ...), never
// the raw values. `brand` / `ink` / `line` / `field` / `chip` are the
// standard's own names, for code that needs one MUI has no slot for.

const baselightTheme = {
  direction: 'ltr',
  palette: {
    primary: {
      main: '#004AAD',
      light: '#EAF0FA',
      dark: '#003F93',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#C25E2A',
      light: '#FBEDE5',
      dark: '#A84E21',
      contrastText: '#ffffff',
    },
    success: {
      main: '#1E8A5A',
      light: '#E4F1EA',
      dark: '#18714A',
      contrastText: '#ffffff',
    },
    info: {
      main: '#004AAD',
      light: '#EAF0FA',
      dark: '#003F93',
      contrastText: '#ffffff',
    },
    // Error text must read on white (AA): the template's coral did not.
    error: {
      main: '#B42318',
      light: '#FEF3F2',
      dark: '#912018',
      contrastText: '#ffffff',
    },
    warning: {
      main: '#B5790C',
      light: '#FAF0D7',
      dark: '#8A5A00',
      contrastText: '#ffffff',
    },
    purple: {
      A50: '#EAF0FA',
      A100: '#004AAD',
      A200: '#51627A',
    },
    grey: {
      100: '#F7FAFC',
      200: '#F2F5F9',
      300: '#E4E9F0',
      400: '#8A99AD',
      500: '#51627A',
      600: '#13243B',
    },
    text: {
      primary: '#13243B',
      secondary: '#51627A',
      disabled: '#8A99AD',
    },
    action: {
      disabledBackground: 'rgba(19,36,59,0.08)',
      hoverOpacity: 0.04,
      hover: '#F2F5F9',
      selected: '#EAF0FA',
    },
    divider: '#E4E9F0',
    background: {
      default: '#F7FAFC',
      paper: '#FFFFFF',
    },
    safrati: {
      brand: '#004AAD',
      brand2: '#003F93',
      accent: '#C25E2A',
      ink: '#13243B',
      ink2: '#51627A',
      ink3: '#8A99AD',
      surface: '#FFFFFF',
      surface2: '#F7FAFC',
      field: '#F2F5F9',
      chip: '#EAF0FA',
      line: '#E4E9F0',
      line2: '#DCE3EC',
      control: '#C8D2DF',
    },
  },
};

// "Blue night": the same roles, tuned for contrast on a dark page.
const baseDarkTheme = {
  direction: 'ltr',
  palette: {
    primary: {
      main: '#5E9BEA',
      light: '#1A2C45',
      dark: '#4E8BE0',
      contrastText: '#0B1320',
    },
    secondary: {
      main: '#E8843A',
      light: '#3A2A1F',
      dark: '#D0712B',
      contrastText: '#0B1320',
    },
    success: {
      main: '#6CD3A0',
      light: '#16342A',
      dark: '#4FBF88',
      contrastText: '#0B1320',
    },
    info: {
      main: '#5E9BEA',
      light: '#1A2C45',
      dark: '#4E8BE0',
      contrastText: '#0B1320',
    },
    error: {
      main: '#FDA29B',
      light: '#3B1F22',
      dark: '#F97066',
      contrastText: '#0B1320',
    },
    warning: {
      main: '#F5C26B',
      light: '#3A2E17',
      dark: '#E5AD4C',
      contrastText: '#0B1320',
    },
    purple: {
      A50: '#1A2C45',
      A100: '#5E9BEA',
      A200: '#A8B6CA',
    },
    grey: {
      100: '#1A2638',
      200: '#22314A',
      300: '#2C3B55',
      400: '#7F8EA6',
      500: '#A8B6CA',
      600: '#EAF1FB',
      A700: '#2C3B55',
    },
    text: {
      primary: '#EAF1FB',
      secondary: '#A8B6CA',
      disabled: '#6F7E96',
    },
    action: {
      disabledBackground: 'rgba(255,255,255,0.08)',
      hoverOpacity: 0.06,
      hover: '#1A2638',
      selected: '#1A2C45',
    },
    divider: '#24324A',
    background: {
      default: '#0B1320',
      dark: '#0B1320',
      paper: '#111C2E',
    },
    safrati: {
      brand: '#5E9BEA',
      brand2: '#4E8BE0',
      accent: '#E8843A',
      ink: '#EAF1FB',
      ink2: '#A8B6CA',
      ink3: '#7F8EA6',
      surface: '#111C2E',
      surface2: '#0B1320',
      field: '#0E1828',
      chip: '#1A2C45',
      line: '#24324A',
      line2: '#2C3B55',
      control: 'rgba(255,255,255,0.24)',
    },
  },
};

export { baseDarkTheme, baselightTheme };
